import React from 'react';
import { DownloadIcon, FileTextIcon } from 'lucide-react';
import Card from '../../components/ui/Card';
import Table from '../../components/ui/Table';
import StatusBadge from '../../components/ui/StatusBadge';
const CashbackSettlement: React.FC = () => {
  const settlements = [{
    id: 'SET-001',
    date: '2023-09-30',
    campaign: 'Q3 Merchant Activation',
    merchants: 450,
    amount: 1250000,
    status: 'processed'
  }, {
    id: 'SET-002',
    date: '2023-10-01',
    campaign: 'Digital Week Bonanza',
    merchants: 120,
    amount: 450000,
    status: 'pending'
  }, {
    id: 'SET-003',
    date: '2023-10-02',
    campaign: 'Super Merchant Rewards',
    merchants: 15,
    amount: 75000,
    status: 'failed'
  }];
  const columns = [{
    header: 'Settlement ID',
    accessor: 'id'
  }, {
    header: 'Date',
    accessor: 'date'
  }, {
    header: 'Campaign',
    accessor: 'campaign'
  }, {
    header: 'Beneficiaries',
    accessor: 'merchants'
  }, {
    header: 'Total Amount',
    accessor: (row: any) => `PKR ${row.amount.toLocaleString()}`
  }, {
    header: 'Status',
    accessor: (row: any) => {
      switch (row.status) {
        case 'processed':
          return <StatusBadge status="success" text="Processed" data-id="element-3580" />;
        case 'pending':
          return <StatusBadge status="warning" text="Pending" data-id="element-3581" />;
        case 'failed':
          return <StatusBadge status="danger" text="Failed" data-id="element-3582" />;
        default:
          return <StatusBadge status="default" text={row.status} data-id="element-3583" />;
      }
    }
  }];
  return <div className="space-y-6" data-id="element-3584">
      <div className="flex justify-between items-center" data-id="element-3585">
        <div data-id="element-3586">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-3587">
            Settlement & Payouts
          </h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400" data-id="element-3588">
            Monitor and process cashback payouts to merchant wallets
          </p>
        </div>
        <button className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-3589">
          <DownloadIcon className="h-4 w-4 mr-2" data-id="element-3590" />
          Export Report
        </button>
      </div>

      <Card data-id="element-3591">
        <Table columns={columns} data={settlements} keyField="id" actions={() => <button className="text-blue-600 hover:text-blue-800" data-id="element-3593">
              <FileTextIcon className="h-5 w-5" data-id="element-3594" />
            </button>} data-id="element-3592" />
      </Card>
    </div>;
};
export default CashbackSettlement;